// Fetch project assemblies for lookup. Create/update happens from paint/welding inspections.
import axios from "axios";

export const GET_PROJECT_ASSEMBLIES = "get_project_assemblies";
export const getProjectAssemblies = (project_id, guid = null) => {
  let url = `/project/${project_id}/assemblies.json`;
  if (guid) {
    url += `?guid=${guid}`;
  }
  const request = axios.get(url);
  return {
    type: GET_PROJECT_ASSEMBLIES,
    payload: request,
  };
};

export const GET_PROJECT_ASSEMBLY_AND_LAST_WI = "get_project_assembly_and_last_wi";
export const getProjectAssemblyAndLastWI = (project_id, guid = "") => {
  let url = `/project/${project_id}/assemblies/assembly_and_last_wi.json?guid=${guid}`;
  const request = axios.get(url);
  return {
    type: GET_PROJECT_ASSEMBLY_AND_LAST_WI,
    payload: request,
  };
};
